import {
    MdOutlineBarChart,
    MdPerson,
    MdFileCopy,
    MdClose,
    MdCheck,
    MdLoop,
    MdMarkEmailUnread,
    MdOutlineMarkEmailUnread,
    MdOutlineViewList,
    MdPeople,
    MdAccessibilityNew,
    MdListAlt,
    MdOutlineLoop,
    MdSummarize,
    MdWarning
} from "react-icons/md";
import {tableColumnsManagement} from "views/admin/ads/variables/tableColumnsManagement";
import tableDataManagement from "views/admin/feedback/variables/tableDataManagement.json";
import Widget from "../../../components/widget/Widget";
import {IoShieldCheckmark} from "react-icons/io5";
import React, {useEffect, useState} from "react";
import Widget3 from "../../../components/widget/Widget3";
import {useUserAuth} from "../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import axios from "axios";
import AdsInfoTable from "./components/AdsInfoTable";

const Advertising = () => {

    var sv = "";

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [totalAds, setTotalAds] = useState(0);
    const [expiredAds, setTotalExpiredAds] = useState(0);
    const [activeAds, setActiveAds] = useState(0);
    const [inActiveAds, setInActiveAds] = useState(0);



    const [allAds, setAllAds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const [message, setErrorMessage] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [hasSubmitted, setHasSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        title: "",
        image: null,
        description: "",
        buttonText: "",
        buttonUrl: "",
        expiryDate: "",
        active: 1
    });

    const [filteredAds, setFilteredAds] = useState([]); // 👈 new state for filtered ads
    const [selectedFilter, setSelectedFilter] = useState("ALL"); // 👈 filter state

    // 🔍 Filter function
    const applyFilter = (filter) => {
        setSelectedFilter(filter);
        if (filter === "ALL") {
            setFilteredAds(allAds);
        } else if (filter === "ACTIVE") {
            setFilteredAds(allAds.filter(ad => ad.active === 1 && compareDateWithToday(ad.expiryDate) !== "Past date"));
        } else if (filter === "EXPIRED") {
            setFilteredAds(allAds.filter(ad => compareDateWithToday(ad.expiryDate) === "Past date"));
        } else if (filter === "INACTIVE") {
            setFilteredAds(allAds.filter(ad => ad.active === 0));
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setFormData((prev) => ({ ...prev, image: files[0] }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleCreate = async () => {
        setHasSubmitted(true);
        if (!validateForm()) return;

        // Construct JSON object
        const adInfo = {
            title: formData.title,
            description: formData.description,
            buttonText: formData.buttonText,
            buttonUrl: formData.buttonUrl,
            expiryDate: formData.expiryDate,
            active: 1
        };

        // Create FormData
        const payload = new FormData();
        payload.append("adsInfo", new Blob([JSON.stringify(adInfo)], { type: "application/json" }));
        payload.append("adImage", formData.image); // keep image as-is

        formData.image = ""

        //console.log(formData)
        const url = CROMPTON_URL + "app/create/senzeAds"
        await axios.post(url, payload, {

            headers: {
                "Content-Type": "multipart/form-data",

                Authorization: decryptedValue
            },
        }).then((response) => {
            //console.log("✅ Ad created successfully");
            setIsModalOpen(false);
            setFormData({
                title: "",
                image: null,
                description: "",
                buttonText: "",
                buttonUrl: "",
                expiryDate: "",
            });

            window.location.reload()


        }).catch((error) => {

            setErrorMessage(error.response.data.message)
            //console.log(error);
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })
    };

    const validateForm = () => {
        const newErrors = {};

        // Title: required
        if (!formData.title.trim()) newErrors.title = "Title is required.";

        // Image: required and must be image file
        if (!formData.image) {
            newErrors.image = "Image is required.";
        } else if (!formData.image.type.startsWith("image/")) {
            newErrors.image = "File must be an image.";
        }

        // Description: required, min 10 chars
        if (!formData.description.trim() || formData.description.length < 10) {
            newErrors.description = "Description must be at least 10 characters.";
        }

        // Button text: required, only letters and spaces
        if (!formData.buttonText.trim()) {
            newErrors.buttonText = "Button text is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.buttonText)) {
            newErrors.buttonText = "Only letters and spaces allowed.";
        }

        // Button URL: required, must be a valid URL
        if (!formData.buttonUrl.trim()) {
            newErrors.buttonUrl = "Button URL is required.";
        } else if (
            !/^https?:\/\/[^\s/$.?#].[^\s]*$/.test(formData.buttonUrl.trim())
        ) {
            newErrors.buttonUrl = "Invalid URL format.";
        }

        // Expiry date: required and not in the past
        const today = new Date();
        const expDate = new Date(formData.expiryDate);
        today.setHours(0, 0, 0, 0);
        if (!formData.expiryDate) {
            newErrors.expiryDate = "Expiry date is required.";
        } else if (expDate < today) {
            newErrors.expiryDate = "Expiry date cannot be in the past.";
        }

        setErrorMessage(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const compareDateWithToday = (dateStr) => {
        if (!dateStr) return "Invalid";

        let inputDate;

        // Case 1: DD/MM/YYYY
        if (dateStr.includes("/")) {
            const [day, month, year] = dateStr.split("/").map(Number);
            inputDate = new Date(year, month - 1, day);
        }
        // Case 2: YYYY-MM-DD
        else if (dateStr.includes("-")) {
            const [year, month, day] = dateStr.split("-").map(Number);
            inputDate = new Date(year, month - 1, day);
        }
        // Fallback
        else {
            inputDate = new Date(dateStr); // try native parse
        }

        if (isNaN(inputDate.getTime())) return "Invalid";

        // Normalize today (ignore time)
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (inputDate < today) {
            return "Past date";
        } else if (inputDate > today) {
            return "Future date";
        } else {
            return "Today";
        }
    };

    useAsyncEffect(async () => {
        setIsLoading(true)

        async function getAllAds() {
            if ((accesscontrollevel.toString() === "1")) {
                var url = CROMPTON_URL + "app/get/all/senzeAds"

                await axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {
                    //console.log(res.data)
                    let expired = 0;
                    let active = 0;
                    let inactive = 0
                    for (const i in res.data) {
                        if (i < (Object.keys(res.data).length)) {
                            const result = compareDateWithToday(res.data[i].expiryDate);
                            //console.log(result)
                            if (result === "Past date") {
                                expired++
                            } else {
                                active++;
                            }

                            if (res.data[i].active === 0) {
                                inactive++
                            }
                        }
                    }
                    setTotalAds(res.data.length);
                    setActiveAds(active)
                    setTotalExpiredAds(expired)
                    setInActiveAds(inactive)
                    setAllAds(res.data)
                    // Default load all ads
                    setFilteredAds(res.data);
                    //console.log(res.data)
                    setIsLoading(false)

                    //getAllFeedbacks()

                }).catch((error) => {
                    setErrorMessage(error.response.data.message)
                    setIsLoading(false)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })

            } else {
                //console.log("Inside stats non admin")
                setIsLoading(false)
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }

        }

        await getAllAds()

        //applyFilter("ACTIVE")

    }, [sv]);

    // ✅ NEW: Apply ACTIVE filter when data loads
    useEffect(() => {
        if (allAds.length > 0) {
            applyFilter("ACTIVE");
        }
    }, [allAds]);

    return (
        isLoading === true ? (
                <div className="spinner">
                    <div
                        className="border-gray-300 h-10 w-10 animate-spin rounded-full border-8 border-t-[#004c86]"/>
                </div>
            )
            :
            (<div className="mt-3 h-full w-full rounded-[20px]">
                    <div
                        className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
                        {/* Total Ads */}
                        <div
                            onClick={() => applyFilter("ALL")}
                            className={`cursor-pointer rounded-2xl transition duration-200 
            ${selectedFilter === "ALL" ? "bg-blue-100 border-2 border-[#004c86]" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdSummarize className="h-6 w-6 text-[#004c86]" />}
                                title={"Total Ads"}
                                subtitle={totalAds}
                            />
                        </div>

                        {/* Active Ads */}
                        <div
                            onClick={() => applyFilter("ACTIVE")}
                            className={`cursor-pointer rounded-2xl transition duration-200 
            ${selectedFilter === "ACTIVE" ? "bg-green-100 border-2 border-green-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdOutlineMarkEmailUnread className="h-7 w-7 text-[#004c86]" />}
                                title={"Active Ads"}
                                subtitle={activeAds}
                            />
                        </div>

                        {/* Expired Ads */}
                        <div
                            onClick={() => applyFilter("EXPIRED")}
                            className={`cursor-pointer rounded-2xl transition duration-200 
            ${selectedFilter === "EXPIRED" ? "bg-red-100 border-2 border-red-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdClose className="h-6 w-6 text-[#004c86]" />}
                                title={"Expired Ads"}
                                subtitle={expiredAds}
                            />
                        </div>

                        {/* Inactive Ads */}
                        <div
                            onClick={() => applyFilter("INACTIVE")}
                            className={`cursor-pointer rounded-2xl transition duration-200 
            ${selectedFilter === "INACTIVE" ? "bg-yellow-100 border-2 border-yellow-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdWarning className="h-6 w-6 text-[#004c86]" />}
                                title={"Inactive Ads"}
                                subtitle={inActiveAds}
                            />
                        </div>
                    </div>

                    <div className="mt-3">
                        <AdsInfoTable
                            tableData={filteredAds}
                            columnsData={tableColumnsManagement}
                        />
                    </div>
                    {/* Create Button */}
                    <div className="mt-5 flex justify-end">
                        <button
                            className="bg-[#004c86] hover:bg-[#0b83b5] text-white font-semibold py-2 px-4 rounded"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Create A New Ad
                        </button>
                    </div>


                    {isModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                            <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-6 w-full max-w-lg shadow-xl transition-colors duration-300">
                                <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white">
                                    Create New Ad
                                </h2>

                                {/* FORM */}
                                <div className="space-y-4">
                                    {/* Title */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Title</label>
                                        <input
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                                        />
                                        {hasSubmitted && message.title && <p className="text-red-500 text-sm">{message.title}</p>}
                                    </div>

                                    {/* Image */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Image</label>
                                        <input
                                            type="file"
                                            name="image"
                                            accept="image/*"
                                            onChange={handleInputChange}
                                            className="w-full"
                                        />
                                        {hasSubmitted && message.image && <p className="text-red-500 text-sm">{message.image}</p>}
                                    </div>

                                    {/* Description */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Description</label>
                                        <textarea
                                            name="description"
                                            rows={3}
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                                        />
                                        {hasSubmitted && message.description && <p className="text-red-500 text-sm">{message.description}</p>}
                                    </div>

                                    {/* Button Text */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Button Text</label>
                                        <input
                                            name="buttonText"
                                            value={formData.buttonText}
                                            onChange={handleInputChange}
                                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                                        />
                                        {hasSubmitted && message.buttonText && <p className="text-red-500 text-sm">{message.buttonText}</p>}
                                    </div>

                                    {/* Button URL */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Button URL</label>
                                        <input
                                            name="buttonUrl"
                                            value={formData.buttonUrl}
                                            onChange={handleInputChange}
                                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                                        />
                                        {hasSubmitted && message.buttonUrl && <p className="text-red-500 text-sm">{message.buttonUrl}</p>}
                                    </div>

                                    {/* Expiry Date */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Expiry Date</label>
                                        <input
                                            type="date"
                                            name="expiryDate"
                                            value={formData.expiryDate}
                                            onChange={handleInputChange}
                                            className="w-full border px-3 py-2 rounded dark:bg-gray-700 dark:text-white"
                                        />
                                        {hasSubmitted && message.expiryDate && <p className="text-red-500 text-sm">{message.expiryDate}</p>}
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="mt-6 flex justify-end space-x-3">
                                    <button
                                        className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-black dark:text-white rounded hover:bg-gray-400"
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-[#004c86] text-white rounded hover:bg-[#0b83b5]"
                                        onClick={handleCreate}
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            )
    );
};

export default Advertising;
